import FormService from '../../../core/services/FormService';
import FetchService from '../../../core/services/FetchService';
import UnitItemListService from '../services/UnitItemListService';
import { action, extendObservable } from 'mobx';
import { Actions } from '../components/unit/unit-item/UnitItemListActions';
import { browserHistory } from 'react-router';
import MoveUnitItemFormDialogService from '../services/MoveUnitItemFormDialogService';
import NotificationService from '../../../core/services/NotificationService';

class UnitItemListActionsService {
  form = new FormService();
  submit = new FetchService();

  constructor() {
    extendObservable(this, {
      enableShift: false,
    });
  }

  handleAction = (courseId, moduleId, unitId, action) => {
    switch (action) {
      case Actions.BACK:
        this.handleBack(moduleId);
        break;
      case Actions.ADD_NEW_ITEM:
        this.handleAddNewItem(moduleId, unitId);
        break;
      case Actions.ITEM_SHIFT:
        this.handleItemShift();
        break;
      case Actions.SHIFT:
        this.handleShift(courseId, moduleId);
        break;
      case Actions.CANCEL:
        this.handleCancel();
        break;
      case Actions.AUDIO:
        this.handleGenerateAudio();
        break;
      case Actions.IMAGE:
        this.handleGenerateImage();
        break;
      default:
        break;
    }
  };

  handleBack = (moduleId) => {
    browserHistory.push(`/modules/${moduleId}/details`);
  };

  handleAddNewItem = (moduleId, unitId) => {
    browserHistory.push(`/modules/${moduleId}/units/${unitId}/items/new`);
  };

  handleShift = action((courseId, moduleId) => {
    MoveUnitItemFormDialogService.open(courseId, moduleId);
  });

  handleItemShift = action(() => {
    UnitItemListService.toggleSelectable();
    this.enableShift = true;
  });

  handleCancel = action(() => {
    UnitItemListService.toggleSelectable();
    this.enableShift = false;
  });

  handleGenerateImage = action(async () => {
    const draftItems = UnitItemListService.items.filter((ui) => ui.item.status === 'DRAFT');
    if (!draftItems.length) {
      NotificationService.addNotification(`No draft items found`, 'error');
      return;
    }

    for await (const [index, draftItem] of draftItems.entries()) {
      if (!draftItem.imagePrompt && !draftItem.postPhraseImagePrompt) {
        await this.submit.fetch({
          method: 'patch',
          url: `/units/${draftItem.unit}/items/${draftItem.item.id}/generate-image-prompt`,
        });
      }

      await this.submit.fetch({
        method: 'patch',
        url: `/units/${draftItem.unit}/items/${draftItem.item.id}/generate-images`,
      });
      NotificationService.addNotification(`${index + 1} of ${draftItems.length} image generated`, 'success');
    }

    UnitItemListService.load();
    NotificationService.addNotification(`Images successfully generated.`, 'success');
  });

  handleGenerateAudio = action(async () => {
    const draftItems = UnitItemListService.items.filter((ui) => ui.item.status === 'DRAFT' && ui.item.character);
    if (!draftItems.length) {
      NotificationService.addNotification(`No draft items with characters found`, 'error');
      return;
    }

    for await (const [index, draftItem] of draftItems.entries()) {
      await this.submit.fetch({
        method: 'patch',
        url: `/units/${draftItem.unit}/items/${draftItem.item.id}/generate-audios`,
      });
      NotificationService.addNotification(`${index + 1} of ${draftItems.length} audios generated`, 'success');
    }

    UnitItemListService.load();
    NotificationService.addNotification(`Images successfully generated.`, 'success');
  });
}

const unitItemListActionsService = new UnitItemListActionsService();

export default unitItemListActionsService;
